import type { Shadows } from '@mui/material/styles';

export const shadows: Shadows = [
  'none', // 0

  // 1 — shadow-xs
  '0px 1px 2px 0px rgba(10, 13, 18, 0.05)',

  // 2 — shadow-sm
  '0px 1px 2px -1px rgba(10, 13, 18, 0.10), 0px 1px 3px 0px rgba(10, 13, 18, 0.10)',

  // 3 — shadow-md
  '0px 2px 4px -2px rgba(10, 13, 18, 0.06), 0px 4px 6px -1px rgba(10, 13, 18, 0.10)',

  // 4 — shadow-lg
  '0px 2px 2px -1px rgba(10, 13, 18, 0.04), 0px 4px 6px -2px rgba(10, 13, 18, 0.03), 0px 12px 16px -4px rgba(10, 13, 18, 0.08)',

  // 5 — shadow-xl
  '0px 3px 3px -1.5px rgba(10, 13, 18, 0.04), 0px 8px 8px -4px rgba(10, 13, 18, 0.03), 0px 20px 24px -4px rgba(10, 13, 18, 0.08)',

  // 6 — shadow-2xl
  '0px 4px 4px -2px rgba(10, 13, 18, 0.04), 0px 24px 48px -12px rgba(10, 13, 18, 0.18)',

  // 7 — shadow-3xl
  '0px 5px 5px -2.5px rgba(10, 13, 18, 0.04), 0px 32px 64px -12px rgba(10, 13, 18, 0.14)',

  // 8–24 — не використовуються, заповнення shadow-3xl
  ...Array(17).fill(
    '0px 5px 5px -2.5px rgba(10, 13, 18, 0.04), 0px 32px 64px -12px rgba(10, 13, 18, 0.14)',
  ),
] as Shadows;
